import { Loader } from '@googlemaps/js-api-loader';

export class LocationService {
  static #googleInstance: typeof google | undefined;

  /**
   * Creates and returns a Google Maps loader instance.
   * Extracted to avoid code duplication.
   */
  private static async createLoader(): Promise<typeof google> {
    if (!LocationService.#googleInstance) {
      const loader = new Loader({
        apiKey: import.meta.env.VITE_GOOGLE_PLACES_API_KEY as string,
        libraries: ['places'],
      });

      LocationService.#googleInstance = await loader.load();
    }

    return LocationService.#googleInstance;
  }

  /**
   * Gets the Google Maps API instance.
   * Used for accessing AutocompleteSuggestion static methods.
   * Note: AutocompleteSuggestion is not a service class - it's a data class
   * with static methods. Use AutocompleteSuggestion.fetchAutocompleteSuggestions()
   * instead of instantiating it.
   */
  static async getGoogleMaps(): Promise<typeof google> {
    return await LocationService.createLoader();
  }

  static destroyService() {
    LocationService.#googleInstance = undefined;
  }
}
